import flatpickr from 'flatpickr';
import { getInput } from '~/js/utils/selectors';
import createAutocomplete from '~/blocks/widget/frontend/autocomplete';
import createDatepicker from '~/blocks/widget/frontend/datepicker';
import WidgetValidation from '~/blocks/widget/frontend/validation';
import { transformBrDateInEnDate } from '~/js/utils/date';
import createWidgetFixedOnScroll from '~/blocks/widget/frontend/fixed-on-scroll';

import Instance = flatpickr.Instance;

function setupWidgets() {
  const fixedWidgetWrapper = document.querySelector(
    '.wp-block-clickbus-widget.is-fixed'
  ) as HTMLDivElement | null;
  if (fixedWidgetWrapper) {
    createWidgetFixedOnScroll(fixedWidgetWrapper);
  }
  const forms = document.querySelectorAll('.widget-form');
  if (!forms.length) return;

  (forms as NodeListOf<HTMLFormElement>).forEach((form) => {
    const originInput = getInput('.widget-origin', form);
    const destinationInput = getInput('.widget-destination', form);
    const onlyToGoInput = getInput('.widget-ida', form);
    const bothToGoInput = getInput('.widget-ida-e-volta', form);
    const startDate = getInput('[name="initial-date"]', form);
    const endDate = getInput('[name="last-date"]', form);

    createAutocomplete(originInput, form);
    createAutocomplete(destinationInput, form);

    const returnDatepicker = createDatepicker(endDate);
    createDatepicker(startDate, returnDatepicker as Instance);

    const reset = () => {
      form.reset();
      originInput.removeAttribute('data-origin');
      destinationInput.removeAttribute('data-destination');
    };

    const validatedForm = new WidgetValidation(form, {
      onSubmit: () => {
        let whitelabelUrl = form.getAttribute('data-whitelabel-url') as string;
        const origin = originInput.getAttribute('data-origin');
        const destination = destinationInput.getAttribute('data-destination');
        let departureDate = startDate.value;
        let returnDate = endDate.value;

        const departureDateInputType = startDate.getAttribute('type');
        const returnDateInputType = startDate.getAttribute('type');

        const utmIsActive = !!Number(form.getAttribute('data-utm-active'));
        const utms = {
          medium: form.getAttribute('data-utm-medium') as string,
          source: form.getAttribute('data-utm-source') as string,
          campaign: form.getAttribute('data-utm-campaign') as string,
        };

        if (departureDate && departureDateInputType !== 'date') {
          departureDate = transformBrDateInEnDate(departureDate);
        }

        if (returnDate && returnDateInputType !== 'date') {
          returnDate = transformBrDateInEnDate(returnDate);
        }

        if (whitelabelUrl.endsWith('/')) {
          whitelabelUrl = whitelabelUrl.slice(0, whitelabelUrl.length - 1);
        }

        const url = new URL(`${whitelabelUrl}/onibus/${origin}/${destination}`);

        if (departureDate) {
          url.searchParams.append('departureDate', departureDate);
        }

        if (returnDate) {
          url.searchParams.append('returnDate', returnDate);
        }

        if (utmIsActive) {
          url.searchParams.append('utm_source', utms.source);
          url.searchParams.append('utm_medium', utms.medium);
          url.searchParams.append('utm_campaign', utms.campaign);
        }

        window.open(url.href);

        reset();
      },
    });

    [originInput, destinationInput].forEach((item) => {
      item.addEventListener('blur', () => {
        if (item.value === '') {
          item.removeAttribute('data-origin');
          item.removeAttribute('data-destination');
          validatedForm.validateField(item);
        }
      });
    });

    onlyToGoInput.addEventListener('change', () => {
      validatedForm.validateForm();
      endDate.setAttribute('disabled', 'true');
      endDate.value = '';
    });

    if (onlyToGoInput && bothToGoInput) {
      bothToGoInput.addEventListener('change', () => {
        endDate.removeAttribute('disabled');
      });
    }
  });
}

export default setupWidgets;
